document.addEventListener('DOMContentLoaded', () => {
    let isMobile = window.innerWidth < 1366;
    const hamburgerMenu = document.querySelector('.sychem-header--primary-nav__actions--mobile-menu');
    const mobileMenu = document.querySelector('.sychem-header--mobile-menu');
    const mobileMenuBack = mobileMenu.querySelector('#sychem-header--mobile-menu__back');
    const topLevelLinks = mobileMenu.querySelectorAll('.top-level-menu-item');
    const subLevelLinks = mobileMenu.querySelectorAll('.dropdown-submenu');
    const headerBlock = document.querySelectorAll('.sychem-header');
    const mobileSearchButton = document.querySelector('.sychem-header--primary-nav__actions--mobile-search');

    function checkScroll() {
        if (window.scrollY > headerBlock[0].offsetHeight) {
            headerBlock[0].classList.add('sticky');
        } else {
            headerBlock[0].classList.remove('sticky');
        }
    }

    function intMobileMenu() {
        initMobileBackBtn()
        initHambergerMenu();
        
        topLevelLinks.forEach((link) => {
            if (link.classList.contains('menu-item-has-children')) {
        
                const linkElement = link.querySelector('.menu-item-title');
                
                linkElement.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();

                    const title = e.target.parentElement.getAttribute('data-title');
                    const id = e.target.parentElement.getAttribute('data-id');

                    if (link.classList.contains('menu-item--active')) {
                        link.classList.remove('menu-item--active');
                        topLevelLinks.forEach((link) => {
                            link.style.display = 'block';
                        });
                        return;
                    }
                    
                    mobileBackBtn(title, id)

                    link.classList.add('menu-item--active');
                    topLevelLinks.forEach((link) => { 
                        if (link !== e.target.parentElement) {
                            link.style.display = 'none';
                        } else {
                            linkElement.style.display = 'none';
                        }
                    });
                });
            }
        });

        subLevelLinks.forEach((link) => {
            const linkElement = link.querySelector('a');
            // link == li element
            // linkElement == a element
            linkElement.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();
                
                const title = e.target.parentElement.getAttribute('data-title');
                const id = e.target.parentElement.getAttribute('data-id');
                const parentId = e.target.parentElement.getAttribute('data-parent-id');

                if (link.classList.contains('menu-item--active')) {
                    link.classList.remove('menu-item--active');
                    topLevelLinks.forEach((link) => {
                        link.style.display = 'block';
                    });
                    return;
                }

                mobileBackBtn(title, id)

                link.classList.add('menu-item--active');
                linkElement.style.display = 'none';

  
                mobileMenu.querySelectorAll('[data-parent-id="' + parentId + '"]').forEach((link) => {
                    if (link.getAttribute('data-title') !== title) {
                        link.style.display = 'none';
                    }
                    
                });
            });
        });
    }

    function initMobileBackBtn() {
        mobileMenuBack.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            // getteh buttn parent element and get the data-title and data-id attributes
            const btnParentElement = e.target.parentElement;
            const id = btnParentElement.getAttribute('data-id');
            
            // Get the current active from the id
            const currentLvl = mobileMenu.querySelector('li[data-id="' + id + '"]');
            
            // remove the menu-item--active class from the parent item
            currentLvl.classList.remove('menu-item--active');
            // remove inline style from the child a element
            currentLvl.querySelector('a').removeAttribute('style');

            // if the currentLvl has a parent-id attribute, 
            parentLvlId = currentLvl.getAttribute('data-parent-id'); 
            if (parentLvlId) {
                // get the parent element
                const parentLvl = mobileMenu.querySelector('li[data-id="' + parentLvlId + '"]');
                // get all the menu-items with in the parentLvl
                if (parentLvl) {
                    const childLvlLinks = mobileMenu.querySelectorAll('[data-parent-id="' + parentLvlId + '"]');
                    // for each link remove the inline style
                    childLvlLinks.forEach((link) => {
                        link.removeAttribute('style');
                    });

                    mobileBackBtn(parentLvl.getAttribute('data-title'), parentLvlId);
                }
            } else {
                currentLvl.querySelector('.menu-item-title').removeAttribute('style');

                const childLvlLinks = mobileMenu.querySelectorAll('[data-depth="0"]');
                // for each link remove the inline style
                childLvlLinks.forEach((link) => {
                    link.removeAttribute('style');
                });

                mobileMenuBack.classList.remove('show');
                mobileMenuBack.setAttribute('data-title', '');
            }
        });
    }

    function initHambergerMenu() {
        hamburgerMenu.addEventListener('click', () => {
            if (mobileMenu.classList.contains('sychem-header--mobile-menu--open')) {
                // --- Reset menu state ---
                // Remove all active classes
                mobileMenu.querySelectorAll('.menu-item--active').forEach(item => {
                    item.classList.remove('menu-item--active');
                });
                // Remove all inline styles from menu items and links
                mobileMenu.querySelectorAll('[style]').forEach(el => {
                    el.removeAttribute('style');
                });
                // Hide and reset the back button
                mobileMenuBack.classList.remove('show');
                mobileMenuBack.setAttribute('data-title', '');
                mobileMenuBack.setAttribute('data-id', '');
                if (mobileMenuBack.querySelector('p')) {
                    mobileMenuBack.querySelector('p').innerText = '';
                }
                // --- End reset ---

                hamburgerMenu.classList.toggle('active');
                mobileMenu.classList.remove('sychem-header--mobile-menu--open');
                document.body.style.overflow = 'auto';
                return;
            }
            hamburgerMenu.classList.toggle('active');
            mobileMenu.classList.add('sychem-header--mobile-menu--open');
            document.body.style.overflow = 'hidden';
        });
        initMobileSearch();
    }

    // init mobile serach button
    function initMobileSearch() {
        if (!mobileSearchButton) {
            return;
        }
        mobileSearchButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();

            hamburgerMenu.click(); 

            if (mobileMenu.classList.contains('sychem-header--mobile-menu--open')) {
                const searchInput = mobileMenu.querySelector('.sychem-header--toolbar__nav--search');
                searchInput.focus();
            }
        });
    }; 

    window.addEventListener('scroll', () => {
        checkScroll();
    });

    window.addEventListener('resize', () => {
        if (window.innerWidth < 1366) {
            if (isMobile) {
                return;
            }
            isMobile = true;
            intMobileMenu();
        } else {
            isMobile = false;
        }
    });

    mobileBackBtn = (title, id) => {
        if (!mobileMenuBack.classList.contains('show')) {
            mobileMenuBack.classList.add('show');
        }

        console.log(title, id);
        
        mobileMenuBack.setAttribute('data-title', title);
        mobileMenuBack.setAttribute('data-id', id);
        mobileMenuBack.querySelector('p').innerText = title;
    }

    if (isMobile) {
        intMobileMenu();
        // if there is an a tag for /downloads/ remove the _blank attribute for the mobile menu
        const downloadLink = mobileMenu.querySelector('a[href="/downloads/"]');
        if (downloadLink) {
            downloadLink.removeAttribute('target');
        }
    } 
});